import {Add as AddIcon, Close as CloseIcon} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import React, {useState} from 'react'
import {useFragment} from 'react-relay'

import MattermostProviderLogo from '../../../../components/MattermostProviderLogo'
import {MenuPosition} from '../../../../hooks/useCoords'
import useMenu from '../../../../hooks/useMenu'
import useMutationProps, {} from '../../../../hooks/useMutationProps'
import {Providers} from '../../../../types/constEnums'
import MattermostConfigMenu from './MattermostConfigMenu'
import MattermostPanel from './MattermostPanel'
import ProviderRow from './ProviderRow'






graphql`
  fragment MattermostProviderRowTeamMember on TeamMember {
    integrations {
      mattermost {
        auth {
          provider {
            id
          }
        }
      }
    }
  }
`
const MattermostProviderRow = (props) => {
  const {viewerRef, teamId} = props
  const viewer = useFragment(
    graphql`
      fragment MattermostProviderRow_viewer on User {
        ...MattermostPanel_viewer
        teamMember(teamId: $teamId) {
          ...MattermostProviderRowTeamMember @relay(mask: false)
        }
      }
    `,
    viewerRef
  )
  const [isConnectClicked, setConnectClicked] = useState(false)
  const {togglePortal, originRef, menuPortal, menuProps} = useMenu(MenuPosition.UPPER_RIGHT)
  const {submitting, submitMutation, onError, onCompleted} = useMutationProps()
  const mutationProps = {submitting, submitMutation, onError, onCompleted} 
  const {teamMember} = viewer
  const {integrations} = teamMember
  const {mattermost} = integrations
  const {auth} = mattermost

  return (
    React.createElement(React.Fragment, null
      , React.createElement(ProviderRow, {
        connected: !!auth,
        onConnectClick: () => setConnectClicked(!isConnectClicked),
        submitting: submitting,
        togglePortal: togglePortal,
        menuRef: originRef,
        providerName: Providers.MATTERMOST_NAME,
        providerDescription: Providers.MATTERMOST_DESC,
        providerLogo: React.createElement(MattermostProviderLogo, null ),
        connectButtonText: !isConnectClicked ? 'Connect' : 'Cancel',
        connectButtonIcon: !isConnectClicked ? React.createElement(AddIcon, null ) : React.createElement(CloseIcon, null ),}

        , (auth || isConnectClicked) && React.createElement(MattermostPanel, { teamId: teamId, viewerRef: viewer,} )
      )
      , auth &&
        menuPortal(
          React.createElement(MattermostConfigMenu, {
            menuProps: menuProps,
            mutationProps: mutationProps,
            providerId: auth.provider.id,}
          )
        )
    )
  )
}

export default MattermostProviderRow
